<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <Form
      :addNewData="openModal"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      @deleteModal="deleteModal()"
      :editMode="editMode"
      :geoName="geoName"
      :geoType="geoType"
      :alertData="alertData"
      :dataCoordinate="dataCoordinate"
      :fleetGroupData="fleetGroupData"
      :dataEdit="dataEdit"
      :title="titleModal"
      :allData="data" />
    <DeleteGeo
      @closeModalDelete="closeModalDelete()"
      @deleteSuccess="deleteSuccess()"
      :dataEdit="dataEdit"
      :title="titleModal"
      :deleteMode="deleteMode"
      :addNewData="openDeleteModal" />

    <vs-table
      ref="table"
      @selected="handleSelected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="data">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="$router.push('/master-data/geofence-detail')">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $t('Add New') }}</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                data.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : data.length
              }}
              of {{ data.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <template slot="thead">
        <vs-th sort-key="no">NO</vs-th>
        <vs-th sort-key="geofence_name">{{ $t('GEOFENCE NAME') }}</vs-th>
        <vs-th sort-key="geofence_category">{{ $t('GEOFENCE CATEGORY') }}</vs-th>
        <vs-th sort-key="fleet_group_name">{{ $t('TYPE') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].indextr">
              <p>{{ indextr + 1 }}</p>
            </vs-td>
            <vs-td :data="data[indextr].geofence_name">
              <p class="product-name font-medium">{{ tr.geofence_name }}</p>
            </vs-td>
            <vs-td :data="data[indextr].geofence_category_name">
              <p class="product-name font-medium">{{ tr.geofence_category_name }}</p>
            </vs-td>
            <vs-td :data="data[indextr].type">
              <p class="product-name font-medium">{{ tr.type }}</p>
            </vs-td>

            <!--<vs-td>-->
            <!--<vs-chip :color="getStatusColor(tr.status)" class="product-order-status">-->
            <!--{{ statusDescription(tr.status) }}-->
            <!--</vs-chip>-->
            <!--</vs-td>-->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Form from './GeofenceForm.vue'
import DeleteGeo from './GeofenceDeleteConfirm.vue'
import * as REPO from '../../../repository/index'

export default {
  components: {
    DeleteGeo,
    Form,
  },
  data() {
    return {
      openModal: false,
      openDeleteModal: false,
      editMode: false,
      deleteMode: false,
      titleModal: 'Add New',
      geoName: '',
      geoType: '',
      selected: [],
      alertData: [],
      fleetGroupData: [],
      dataCoordinate: [],
      dataEdit: {},
      data: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  methods: {
    deleteSuccess() {
      this.$vs.loading({
        container: '#data-list-list-view',
        scale: 1,
      })
      this.openDeleteModal = false
      this.getData()
    },
    deleteModal() {
      //
      this.openModal = false
      this.deleteMode = true
      this.titleModal = 'Delete Data'
      this.openDeleteModal = true
    },
    addNew() {
      this.editMode = false
      this.titleModal = 'Add New'
      this.dataEdit = {}
      this.openModal = true
    },
    getData() {
      REPO.getListGeofence()
        .then((res) => {
          this.data = res.data.data
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close()
        })
        .catch((err) => {
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close()
          this.$toast.error(err.message)
        })
    },
    statusDescription(val) {
      if (val == 1) {
        return 'Active'
      } else {
        return 'Non Active'
      }
    },
    handleSelected(tr) {
      this.geoName = tr.geofence_name
      this.geoType = tr.type

      // this.$vs.loading();

      if (tr.type == 'CIRCLE') {
        this.dataCoordinate = tr.geofence_detail.coordinates
      } else {
        this.dataCoordinate = tr.geofence_detail.coordinates[0]
      }

      this.$vs.loading.close()
      this.editMode = true
      this.titleModal = 'Preview'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.openModal = true
      // REPO.getGeofenceDetail(tr.id).then(res => {
      //
      // }).catch(err=>{
      //     this.$vs.loading.close();
      //     this.$vs.notify({
      //         time: 2500,
      //         title: 'Error',
      //         text: err.message,
      //         iconPack: 'feather',
      //         icon: 'icon-alert-circle',
      //         color: 'danger'
      //     });
      // });
    },
    closeModal() {
      //
      this.openModal = false
    },
    closeModalDelete() {
      this.openDeleteModal = false
    },
    submitModal() {
      this.openModal = false
      this.getData()
    },
    getStatusColor(status) {
      if (status == '0') return 'danger'
      if (status == '1') return 'success'
      return 'primary'
    },
    getPopularityColor(num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    formatData(data) {
      // formats data received from API
      let formattedData = data.map((item) => {
        const fields = item.fields
        let obj = {}
        for (const key of Object.keys(fields)) {
          obj[key] =
            fields[key].stringValue ||
            fields[key].integerValue ||
            fields[key].doubleValue
        }
        return obj
      })
      return formattedData
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$vs.loading({
      container: '#data-list-list-view',
      scale: 1,
    })
    this.isMounted = true
  },
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
